import React from 'react';

import styles from "./Footer.module.css";
import FooterLogo from './FooterLogo';


const DoulaOnBoardingFooter: React.FC = () => {
	return (
		<footer className={`${styles.footer} bg-newTheme-spruce py-12`}>
			<div className={`${styles.footerContainer} px-4 sm:px-6 xl:px-0`}>
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
					{/* Brand */}
					<div className="flex flex-col items-center lg:items-start space-y-4">
						<div className="flex items-center space-x-2">
							<div className={styles.footerLogo}>
								<FooterLogo />
							</div>
						</div>
						<p className="font-karla text-center lg:text-left">
							Connecting families with certified doulas for personalized birth
							support.
						</p>
					</div>

					{/* Copyright and Legal Links */}
					<div className="text-center self-center lg:text-right">
						<p className="font-karla">&copy; {new Date().getFullYear()} Gaia</p>
						<p className="font-karla text-sm mt-1">
							All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</footer >
	)
};

export default DoulaOnBoardingFooter;